import { render, staticRenderFns } from "./CopyNeedsForm.vue?vue&type=template&id=1d35f449&"
import script from "./CopyNeedsForm.vue?vue&type=script&lang=js&"
export * from "./CopyNeedsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CopyNeedsForm.vue"
export default component.exports